<template>
  <el-dialog title="修改货期" :visible.sync="disableDialog" width="437px">
    <el-form label-width="100px">
      <!-- <el-form-item label="类型：" :rules="filter_rules({required:true})">
        <el-select v-model="value" style="width:240px">
          <el-option label="现货" value="现货"></el-option>
          <el-option label="期货" value="期货"></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="期望货期：" :rules="filter_rules({required:true})">
        <el-input
          style="width:50%"
          oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          v-model="value"
          label="请输入期望货期"
        ></el-input>
        <span style="margin-left:10px">天</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-center">
      <el-button type="primary" @click="onSubmit">确 定</el-button>
      <el-button @click="disableDialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      disableDialog: false,
      value: null
    }
  },
  methods: {
    // 修改期货初始
    onInitial () {
      this.value = null
      this.disableDialog = true
    },
    // 确定
    onSubmit () {
      if (!this.value) {
        this.$message.error('请输入期望货期！')
        return
      }
      this.$emit('onUpdateDate', this.value)
      this.disableDialog = false
    }
  }
}
</script>
